export const getDropTargetId = (el: HTMLElement) => el?.dataset?.dropId || el?.dataset?.id
export const getDropTargetType = (el: HTMLElement) => el?.dataset?.dropType || el?.dataset?.type

export const getDropTargetResource = (el: HTMLElement) => {
    if (!el) {
        return
    }

    const id = getDropTargetId(el)
    const type = getDropTargetType(el)

    if (!id || !type) {
        return
    }

    return { id, type }
}